import React, { useState } from 'react';
import { Box, Drawer, Toolbar } from '@mui/material';
import SidebarContent from './SidebarContent';
// import './sidebar-select.scss';

// const drawerWidth = 250;

interface SidebarProps {
  setSidebarOpen: (open: boolean) => void; // Thêm prop để nhận giá trị từ bên ngoài
}

const Sidebar: React.FC<SidebarProps> = ({ setSidebarOpen }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [drawerWidth,setDrawerWidth] = useState(250);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    
     
      <Drawer
        variant="permanent"
        
        
        sx={{
          display: 'flex',
         
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: { position: 'initial', width: drawerWidth },
        }}
        open
      >
        {/* <Toolbar /> */}
        <Box >
          <SidebarContent  drawerWidth={drawerWidth}  setDrawerWidth={setDrawerWidth} setSidebarOpen={setSidebarOpen} />
        </Box>
      </Drawer>
    
  );
};

export default Sidebar;

